/**
 * useHistoryMigration
 *
 * Watches for auth state transitions (anonymous → logged in).
 * On login, migrates in-memory session history to Firestore.
 */

import { useEffect, useRef } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useSearchHistoryStore } from '../stores/searchHistoryStore';
import { useRiskReportStore } from '../stores/riskReportStore';

export function useHistoryMigration(): void {
  const { user } = useAuth();
  const prevUserId = useRef<string | null>(null);

  const migrateSearch = useSearchHistoryStore((s) => s.migrateSessionToFirestore);
  const migrateReports = useRiskReportStore((s) => s.migrateSessionToFirestore);

  useEffect(() => {
    // Detect login: was null, now has value
    if (!prevUserId.current && user?.uid) {
      migrateSearch(user.uid);
      migrateReports(user.uid);
    }
    prevUserId.current = user?.uid ?? null;
  }, [user?.uid, migrateSearch, migrateReports]);
}
